import { Navigate, Route, Routes } from "react-router-dom";
import { LoginPage } from "./pages/LoginPage";
import { ChangePasswordPage } from "./pages/ChangePasswordPage";
import { LegalRoute } from "./pages/LegalRoute";
import { HomePage } from "./pages/HomePage";
import { AppShell } from "./pages/AppShell";
import { PartnerFilesPage } from "./pages/partner/PartnerFilesPage";
import { StaffSharingsPage } from "./pages/staff/StaffSharingsPage";
import { StaffSharingDetailPage } from "./pages/staff/StaffSharingDetailPage";
import { RequireAuth } from "./routes/RequireAuth";
import { RequireRole } from "./routes/RequireRole";

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/login/staff" element={<LoginPage />} />
      <Route path="/legal" element={<LegalRoute />} />

      <Route element={<RequireAuth />}>
        <Route path="/change-password" element={<ChangePasswordPage />} />

        <Route element={<AppShell />}>
          <Route path="/" element={<HomePage />} />

          <Route element={<RequireRole role="partner" />}>
            <Route path="/files" element={<PartnerFilesPage />} />
          </Route>

          {/*
            No dedicated staff "Files" overview: docs/api/portal-api.yaml
            has no route for it (only /sharings and /sharings/{code}), so
            staff land on Sharings (HomePage) and browse a partner's files
            from that sharing's detail page instead of a placeholder.
          */}
          <Route element={<RequireRole role="staff" />}>
            <Route path="/staff/sharings" element={<StaffSharingsPage />} />
            <Route path="/staff/sharings/:code" element={<StaffSharingDetailPage />} />
          </Route>
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
